module.exports = __webpack_public_path__ + "assets/img/fix_open_mobileEn.a0e33c39.png";